
$('.js-slider-picking').slick({
 	dots: false,
 	infinite: false,
 	adaptiveHeight: true,
 	draggable: false,
 	swipe: false,
 	prevArrow: '<a href="#" class="picking-body__arrow picking-body__arrow-left hidden"><svg class="icon" width="33px" height="12px"><use xlink:href="#arrow-small"></use></svg></a>',
    nextArrow: '<a href="#" class="picking-body__arrow picking-body__arrow-right disable"><svg class="icon" width="33px" height="12px"><use xlink:href="#arrow-small"></use></svg></a>'
});

$('.js-slider-picking').on('afterChange', function(event, slick, currentSlide, nextSlide) {
	var tab = $('.picking-menu__item');
	var thisSlide = slick.$slideTrack.children()[currentSlide];
	var thisSlideItem = $(thisSlide).find('.picking-body__item');
	var sliderLength = $(this).slick("getSlick").slideCount - 1;

	//пока не выбран вариант пункты меню не активны

	for (var i=0; i < tab.length; i++) {
		var tabIndex = $(tab[i]);
		if (currentSlide == tabIndex.attr('data-tab')) {
			tabIndex.addClass('active');
			tabIndex.addClass('visited');
			tabIndex.siblings().removeClass('active');
		}
	}

	//пока не выбран вариает стрелки не активны

	if(thisSlideItem.hasClass('checked')) {
		$('.picking-body__arrow-right').removeClass('disable');
	} else {
		$('.picking-body__arrow-right').addClass('disable');
	}

	//скрывать стрелки налево или направо на первом и последнем слайдере

	if (currentSlide == 0) {
		$('.picking-body__arrow-left').addClass('hidden');
	} else {
		$('.picking-body__arrow-left').removeClass('hidden');
	} 

	if (currentSlide == sliderLength) {
		$('.picking-body__arrow-right').addClass('hidden');
	} else {
		$('.picking-body__arrow-right').removeClass('hidden');
	}

});

//по клику на пункт меню прокрутка до нужного слайда

$('.picking-menu__item').on('click', function(e) {
	e.preventDefault();
	if ($(this).hasClass('visited')) {
		$(this).addClass('active');
		$(this).siblings().removeClass('active');
		var index = $(this).attr('data-tab');
		$('.js-slider-picking').slick('slickGoTo', index);
	}
})

//при выборе варианта прокрутка на следующий слайд

$('.picking-body__item').on('click', function(e) {
	e.preventDefault();
	$(this).toggleClass('checked');
	$('.picking-body__arrow-right').removeClass('disable');
	$(this).siblings().removeClass('checked');

	var thisSlide = $('.js-slider-picking').slick('slickCurrentSlide');
	var LastItem = $('.js-slider-picking').slick("getSlick").slideCount - 1;
	
	if (thisSlide == LastItem) {
		$('html, body').animate({scrollTop: $('.picking-body__btn').offset().top - 100}, 500);
	} else {
		$('.js-slider-picking').slick('slickNext');
		if ($(window).width() < 768) {
			$('html, body').animate({scrollTop: 50}, 500);
		}
	}
});


